import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { fetchApp } from '../../store/apps/actions';
import { getRoadBookConfigurations } from '../../store/roadBookConfigurations/actions';
import Loading from '../../components/common/Loading/Loading';
import RoadBookConfigurationList
    from '../../components/roadbook/RoadBookConfigurationList/RoadBookConfigurationList';
import withTranslation from '../../hoc/withTranslation';
import AdminService, { SUPER_ADMIN } from '../../services/admin';
import { FloatingActionButton } from 'material-ui';
import styles from '../page/Pages.css';
import ContentAdd from 'material-ui/svg-icons/content/add';
import { ADD_ROAD_BOOK_CONFIGURATION_PAGE } from '../../constants/routes';

export class RoadBookListPage extends React.Component {

    componentWillMount() {
        this.fetchApplication();
        this.fetchRoadBookConfigurations();
    }

    fetchRoadBookConfigurations(appId = null) {
        if (this.props.match) {
            let app = appId || this.props.match.params.appId;
            if (app && this.props.roadBookConfigurations === null) {
                const withDisabled = AdminService.isAuthorized(SUPER_ADMIN, this.props.user);
                this.props.getRoadBookConfigurations(app, this.props.currentLang, withDisabled);
            }
        }
    }
    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id)
            }
        }
    }
    onAddButtonClicked = () => {
        this.props.history.push(
            ADD_ROAD_BOOK_CONFIGURATION_PAGE.replace(':appId', this.props.app.id)
        );
    };

    renderFloatingButton() {
        return (
            <div>
                <FloatingActionButton
                    style={styles.floatingButton}
                    onClick={this.onAddButtonClicked}
                >
                    <ContentAdd />
                </FloatingActionButton>
            </div>
        );
    }

    render() {
        return (<div>
            {(!this.props.app || this.props.loading) && <Loading paper={false} />}
            {!this.props.loading && this.props.roadBookConfigurations
                && <RoadBookConfigurationList
                    app={this.props.app}
                    user={this.props.user}
                    roadBookConfigurations={this.props.roadBookConfigurations}
                    title={this.props.t('module.road_book.available')}
                    currentLang={this.props.currentLang}
                />
            }
            {this.renderFloatingButton()}
        </div>);
    }
}

function mapStateToProps(state) {
    return {
        currentLang: state.ui.currentLang,
        loading: state.apps.pending || state.roadBookConfigurations.pending,
        error: state.apps.error || state.roadBookConfigurations.error,
        user: state.auth.content,
        app: state.apps.currentApplication,
        sending: state.roadBookConfigurations.sending,
        roadBookConfigurations: state.roadBookConfigurations.content
    };
}

export default connect(mapStateToProps, {
    fetchApp,
    getRoadBookConfigurations
})(withRouter(withTranslation(RoadBookListPage)));



// WEBPACK FOOTER //
// src/containers/roadbook/RoadBookListPage.js